import { SxProps, Theme } from "@mui/material/styles";
import { gris2 } from "../../../theme";

const styles: SxProps<Theme> = [
  {
    "&.formContainer": {
      width: "40%",
      margin: "auto",
      marginTop: "5%",
    },
    "& .icon": {
      color: gris2,
      marginRight: 8,
    },
  },
];

export default styles;
